module.exports = __webpack_public_path__ + "img/logo-ez.4e94e1b4.svg";